// src/config/firmProfile.js

const FirmProfile = {
  COMPANY_NAME: "Aspire Tax and Bookkeeping Pty Ltd",
  LOGO_URL: "/assets/aspire-logo.png", // Assuming this exists or will utilize a placeholder/text if not
  FOOTER_ABN_LINE: "Registered Tax agents and Public Accountants with ABN 45 692 343 445",
  CONTACT_DETAILS: {
    phone: "+61 449 609 681", // Placeholder or actual if known. Using generic from prompt context or safe default.
    email: "info@aspiretaxbook.com.au",
    address: "12 Klandy Drive Kalkallo, VIC, 3064, Australia",
    website: "www.aspiretaxbook.com.au"
  },
  PRINCIPAL_SIGNER: {
    name: "Muhammad Shahid Jamil",
    title: "Principal Accountant/Director"
  }
};

export default FirmProfile;
